import { StoryblokImageTextColContainer } from './StoryblokImageTextColContainer'

import { createImageTextColContainer } from './__mocks__/imageTextColContainer'

export { createImageTextColContainer }

// Re-export for backward compatibility
export const dummyBlokImageTextColContainerStoryblok = createImageTextColContainer()

export default StoryblokImageTextColContainer
